import { RewriteChannel } from '@/services/api'
import clsx from 'clsx'

interface SectionItem {
  type: string
  title: string
}

interface SectionListProps {
  channels: RewriteChannel[]
  activeChannelId: string | null
  activeSectionIndex: number
  onSelectSection: (index: number) => void
}

function getChannelSections(channel: RewriteChannel): SectionItem[] {
  const structure = typeof channel.structure === 'string' ? JSON.parse(channel.structure) : channel.structure
  const st = structure as { sections?: SectionItem[] }
  return st?.sections || []
}

const SECTION_ICONS: Record<string, string> = {
  cover: '🎨',
  intro: '📖',
  body: '📄',
  closing: '🔚',
  hook: '🪝',
  main: '📋',
  cta: '📣',
}

export function SectionList({ channels, activeChannelId, activeSectionIndex, onSelectSection }: SectionListProps) {
  const channel = channels.find(c => c.id === activeChannelId)
  if (!channel) {
    return (
      <div className="p-4 text-sm text-text-tertiary">
        채널을 선택하면 섹션이 표시됩니다.
      </div>
    )
  }

  const sections = getChannelSections(channel)

  return (
    <div className="flex flex-col h-full">
      <div className="px-3 py-2 border-b border-border-subtle bg-bg-secondary/20">
        <span className="text-xs font-bold text-text-secondary uppercase tracking-wider">섹션</span>
      </div>
      <div className="flex-1 overflow-y-auto py-1">
        {sections.map((section, idx) => {
          const icon = SECTION_ICONS[section.type] || '📄'
          return (
            <button
              key={idx}
              onClick={() => onSelectSection(idx)}
              className={clsx(
                'w-full text-left px-3 py-2.5 flex items-center gap-2.5 transition-all border-l-2',
                activeSectionIndex === idx
                  ? 'border-primary bg-primary/5 text-text-primary'
                  : 'border-transparent hover:bg-bg-elevated text-text-secondary hover:text-text-primary'
              )}
            >
              <span className="text-base">{icon}</span>
              <div className="min-w-0">
                <span className="text-sm font-medium block">{section.title}</span>
                <span className="text-xs text-text-tertiary">{section.type}</span>
              </div>
            </button>
          )
        })}
      </div>
    </div>
  )
}

export { getChannelSections }
export type { SectionItem }
